import { memo } from "react";
import LoaderBar from "app/pages/.shared/LoaderBar/LoaderBar";
import "./LuggagePlaceholderLoader.scss";
import { BaggageMFilledIcon, BaggageLFilledIcon } from "app/icons/travel";

const LuggagePlaceholderLoader = () => {
	return (
		<div className="luggage-placeholder">
			<div className="luggage-placeholder__loader">
				<div className="luggage-placeholder__loader-icon">
					<BaggageMFilledIcon />
				</div>
				<LoaderBar />
			</div>
			<div className="luggage-placeholder__loader">
				<div className="luggage-placeholder__loader-icon">
					<BaggageLFilledIcon />
				</div>
				<LoaderBar />
			</div>
		</div>
	);
};

export default memo(LuggagePlaceholderLoader);
